import React, { useEffect } from 'react';
import { useIsMount } from '../../../hooks/useIsMountHook';
import { handleFocus } from '../../../utils/commonUtil';

/**
 * Autofocus wrapper for input elements. It will create focus on any child element passed through children.
 */
const Autofocus = (props: { children: any }) => {
  const isMount = useIsMount();
  const ref: React.RefObject<any> = React.createRef();

  const childrenWithProps = React.Children.map(props.children, child => {
    // Checking isValidElement is the safe way and avoids a typescript
    // error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ref } as any);
    }
    return child;
  });

  useEffect(() => {
    if (isMount) {
      handleFocus(ref.current);
    }
  }, []);
  return <>{childrenWithProps}</>;
};

export default Autofocus;
